import React from "react";
import { Loading } from '../shared/constants/texts.js';

export const Products = (props) => {
  const handleProductClick = (route) => {
    if (route) {
      window.open(route, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div id="products" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Nossos Produtos</h2>
          <p>
            Soluções completas e prontas para impulsionar o crescimento do seu negócio. 
            Nossos produtos foram desenvolvidos com base em anos de experiência e necessidades reais do mercado.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.title}-${i}`} className="col-md-4 col-sm-6">
                <div 
                  className="product-item"
                  onClick={() => handleProductClick(d.route)}
                  style={{
                    cursor: d.route ? 'pointer' : 'default',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    if (d.route) {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (d.route) {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '';
                    }
                  }}
                >
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.description}</p>
                  {/* <div className="product-technologies">
                    {d.technologies.map((tech, index) => (
                      <span key={`${tech}-${index}`} className="tech-badge">
                        {tech}
                      </span>
                    ))}
                  </div> */}
                  {/* <div className={`product-status ${d.status === 'Disponível' ? 'available' : 'development'}`}>
                    <span>{d.status}</span>
                  </div> */}
                </div>
              </div>
            ))
            : Loading}
        </div>
        <div className="row" style={{marginTop: '40px'}}>
          <div className="col-md-12">
            <p className="products-cta">
              Interessado em conhecer melhor nossos produtos? 
              <a href="#contact" className="page-scroll"> Entre em contato</a> para agendar uma demonstração.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
